import { client } from './client';
import { endpoints } from './endpoints';

export interface Size {
  arSizeName: string;
  enSizeName: string;
  price: number;
}

export interface Item {
  itemUUID: string;
  arName: string;
  enName: string;
  availability: boolean;
  sizes: Size[];
}

export interface Category {
  categoryUUID: string;
  arName: string;
  enName: string;
  availability: boolean;
  items: Item[];
}

export interface BranchMenu {
  availability: boolean;
  categories: Category[];
}

export async function fetchMenuDetailsApi(
  branchUUID: string,
  menuUUID: string,
): Promise<BranchMenu> {
  const response = await client.get(
    endpoints.MENU_DETAILS(branchUUID, menuUUID),
  );

  return response.data;
}
